import { IsoDate, IsoDateTime, IsoDateTimeTz, IsoDuration } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { constructDate } from '../../helper/construct-date.function';

export function subtractDuration<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T, duration: IsoDuration) {
  const deconstructedDate = deconstructDate(input);
  if(deconstructedDate._type !== 'date'
    && deconstructedDate._type !== 'dateTime'
    && deconstructedDate._type !== 'dateTimeTz') {
    throw new Error('addDays: invalid ISO date/date-time string');
  }
  const deconstructedDuration = deconstructDate(duration);
  if(deconstructedDuration._type !== 'duration') {
    throw new Error('addDays: invalid ISO duration string');
  }
  if(deconstructedDate._type === 'date') {
    const {year, month, day} = deconstructedDate;
    const dt = new Date(Date.UTC(year, month - 1, day));
    dt.setUTCDate(dt.getUTCDate() - deconstructedDuration.days);
    dt.setUTCMonth(dt.getUTCMonth() - deconstructedDuration.months);
    dt.setUTCFullYear(dt.getUTCFullYear() - deconstructedDuration.years);
    deconstructedDate.year = dt.getUTCFullYear();
    deconstructedDate.month = dt.getUTCMonth() + 1;
    deconstructedDate.day = dt.getUTCDate();
  }
  if(deconstructedDate._type === 'dateTime' || deconstructedDate._type === 'dateTimeTz') {
    const {year, month, day, hours, minutes, seconds, milliseconds} = deconstructedDate;
    const dt = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds, milliseconds));
    dt.setUTCMilliseconds(dt.getUTCMilliseconds() - deconstructedDuration.milliseconds);
    dt.setUTCSeconds(dt.getUTCSeconds() - deconstructedDuration.seconds);
    dt.setUTCMinutes(dt.getUTCMinutes() - deconstructedDuration.minutes);
    dt.setUTCHours(dt.getUTCHours() - deconstructedDuration.hours);
    dt.setUTCDate(dt.getUTCDate() - deconstructedDuration.days);
    dt.setUTCMonth(dt.getUTCMonth() - deconstructedDuration.months);
    dt.setUTCFullYear(dt.getUTCFullYear()- deconstructedDuration.years);
    deconstructedDate.year = dt.getUTCFullYear();
    deconstructedDate.month = dt.getUTCMonth() + 1;
    deconstructedDate.day = dt.getUTCDate();
    deconstructedDate.hours = dt.getUTCHours();
    deconstructedDate.minutes = dt.getUTCMinutes();
    deconstructedDate.seconds = dt.getUTCSeconds();
    deconstructedDate.milliseconds = dt.getUTCMilliseconds();
  }

  return constructDate(deconstructedDate) as unknown as T;
}
